import { Api } from "@mcleod/core";
import { AutogenLayoutInvoiceProcessingProfileFilter } from "./autogen/AutogenLayoutInvoiceProcessingProfileFilter";
import { InvoiceProcessingProfile } from "./InvoiceProcessingProfile";

export class InvoiceProcessingProfileFilter extends AutogenLayoutInvoiceProcessingProfileFilter {
    async onLoad(): Promise<void> {
        const profileLayout = this.layoutProfile as InvoiceProcessingProfile;
        profileLayout.textboxId.required = false;
        profileLayout.textboxTitle.required = false;
        profileLayout.textboxBillType.required = false;
        profileLayout.textboxBillStatus.required = false;
        profileLayout.layoutProfileColor.visible = false;
        profileLayout.layoutProfileColor.marginLeft = 0;
        const response = await Api.post("lme/general/segment-code-enabled");
        profileLayout.textboxOrderAllocations.visible = response?.data[0]?.enabled;
        profileLayout.checkboxOrderAllocationExclude.visible = response?.data[0]?.enabled;
    }

}
